<template>
  <div class="home">
    <div class="container-fluid">
      <!-- <Transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut"> -->
      <div class="personnal-informations-container hidden-print">
        <div class="wrapper">
          <UserInputForm @compute="processUserInput" @print="print" />
        </div>
      </div>
      <!-- </Transition> -->

      <Transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut">
        <template v-if="displayResult">
          <div id="simulation-result" class="simulation-result-container">
            <div class="wrapper">
              <div class="alert alert-info mb-4 hidden-print">
                <div class="inner">
                  <div class="ampoule">
                    <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0C3.14 0 0 3.14 0 7C0 9.38 1.19 11.47 3 12.74V15C3 15.55 3.45 16 4 16H10C10.55 16 11 15.55 11 15V12.74C12.81 11.47 14 9.38 14 7C14 3.14 10.86 0 7 0ZM4 19C4 19.55 4.45 20 5 20H9C9.55 20 10 19.55 10 19V18H4V19ZM9 11.7L9.85 11.1C11.2 10.16 12 8.63 12 7C12 4.24 9.76 2 7 2C4.24 2 2 4.24 2 7C2 8.63 2.8 10.16 4.15 11.1L5 11.7V14H9V11.7Z" fill="white"></path>
                    </svg>
                  </div>
                  <p>
                    Le tableau ci-contre présente une estimation des garanties sur la base des éléments communiqués.<br />
                    Les paramètres de calcul utilisés sont des moyennes.
                  </p>
                  <p>En cas de sinistre, chaque situation personnelle devra être analysée sur la base de votre dernier bulletin de paie afin de déterminer le montant exact de l'indemnisation due au titre du contrat.</p>
                  <p>
                    Votre rémunération mensuelle brute à considérer correspond à votre traitement brut additionné le cas échéant de la NBI et des primes à caractère permanent conformément à l’accord ministériel du 20 octobre 2023.<br />
                    Les primes à périodicité non mensuelle sont à proratiser.<br />
                    La Participation PSC, le remboursement Domicile Travail, le forfait télétravail, et les indemnités de remboursement de frais ne sont pas à prendre en compte conformément à l'article 25 du Décret 86-442 du 14 mars 1986.<br />
                    La cotisation est présentée après déduction de la participation de votre employeur de 7 Euros.
                  </p>
                  <p>Les données renseignées dans le simulateur ne seront pas enregistrées, elles servent uniquement à vous proposer une simulation à titre informatif.</p>
                </div>
              </div>
              <DisplayResult :userInput="userInput" :resultats="displayResult" :fullDisplay="fullDisplay" />
            </div>
          </div>
        </template>
      </Transition>
    </div>
  </div>
</template>

<script>
import objectHelper from "@/classes/helpers/objectHelper";
import simulationService from "@/classes/services/simulationService";
import UserInformations from "@/classes/dto/userInformations";
import UserInputForm from "@/components/UserInputForm";
import DisplayResult from "@/components/DisplayResult";

export default {
  name: "HomeView",
  components: {
    UserInputForm,
    DisplayResult,
  },
  data() {
    return {
      objectHelper,
      userInput: new UserInformations(),
      displayResult: undefined,
      fullDisplay: false,
    };
  },
  methods: {
    processUserInput(event) {
      this.userInput = new UserInformations(event);
      this.displayResult = simulationService.compute(event);
    },
    print() {
      document.title = "Vivinter SPM - Ma simulation";
      this.fullDisplay = true;

      setTimeout(() => {
        window.print();

        setTimeout(() => {
          document.title = "Mise en place SPM Agents - Vivinter SPM";
          this.fullDisplay = false;
        }, 500);
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";
@import "@/assets/styles/_mixins.scss";

$wrapper-base-width: 1000px;
$bs-gutter-x: 1.5rem;
$bs-gutter-y: 0;

.personnal-informations-container,
.simulation-result-container {
  margin-top: calc($bs-gutter-y * -1);
  margin-right: calc($bs-gutter-x * -0.5);
  margin-left: calc($bs-gutter-x * -0.5);

  .wrapper {
    max-width: $wrapper-base-width;
    margin: 0 auto;
    padding: 1.5rem 0;

    @media (max-width: $screen-md-max) {
      max-width: $screen-md-max !important;
    }

    @media (max-width: $screen-sm-max) {
      margin: 0rem auto !important;
      padding: 2rem 0;
      border-radius: 0 !important;

      max-width: $screen-sm-max !important;
    }

    @media (max-width: $screen-xs-max) {
      max-width: $screen-xs-max !important;
    }
  }
}

.personnal-informations-container {
  .wrapper {
    margin-top: 1rem;
    margin-bottom: 10px;
    background: white url("@/assets/images/fond_vivinter.svg") right center no-repeat;
    background-size: auto 100%;
    @include shadow(5px);

    @media (max-width: $wrapper-base-width) {
      margin-top: 0;
      box-shadow: none;
      border-radius: 0;
    }

    @media (max-width: $screen-xs-max) {
      background: $gradient-siaci;
    }
  }
}

.simulation-result-container {
  .wrapper {
    $colToggleWidth: 1.25rem;

    @media (max-width: calc($screen-md-max + $colToggleWidth + 1rem)) {
      margin-right: 1rem;
      margin-left: calc($colToggleWidth / 2);
    }
  }
}
</style>
